/**
 * Saves data in local storage and set expiry time.
 */
import {CACHE_TTL} from "../driverPackageSummary/constants/DriverPackageSummaryConstants";


export function setDataWithExpiry(key, value) {
    try {
        const currTime = (value.lastUpdated === undefined)? new Date().getTime() : value.lastUpdated
        const record = {
            data: value,
            lastUpdated: currTime,
            expiry: currTime + CACHE_TTL
        }
        localStorage.setItem(key, JSON.stringify(record));
    } catch (e) {
    }
}

/**
 * Retrieves data from local storage if not expired, null otherwise.
 */
export function getDataWithExpiry(key) {
    const response = {cachedData: null, lastUpdated: null}
    try {
        const storedJson = localStorage.getItem(key) || null;
        if (!storedJson) {
            return response
        }
        const record = JSON.parse(storedJson)
        const now = new Date()

        // compare the expiry time of the item with the current time
        if (now.getTime() > record.expiry) {
            // cache is expired
            localStorage.removeItem(key)
            return response
        }
        response.cachedData = record.data
        response.lastUpdated = record.lastUpdated
        return response;
    } catch (e) {
        return response;
    }
}



// WEBPACK FOOTER //
// ./src/components/util/CacheManager.js